class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);


/* 
Atributo en carrito checkbox de regalo
*/

document.addEventListener('change', function (event) {

  const checkbox = event.target.closest(
    '#cart-gift-checkbox, #mini-cart-gift-checkbox'
  );

  if (checkbox) {

    const container = checkbox.closest(
      '.gift-cart-attributes, .mini-cart__gift-attributes'
    );

    const messageBox = container
      ? container.querySelector(
          '.gift-cart-attributes__message, .mini-cart__gift-message'
        )
      : null;

    const messageInput = container
      ? container.querySelector(
          '#cart-gift-message, #mini-cart-gift-message'
        )
      : null;

    if (messageBox) {
      messageBox.hidden = !checkbox.checked;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Este es un regalo.': checkbox.checked ? 'Sí' : '',
          'Escribe aquí tu mensajito':
            checkbox.checked && messageInput
              ? messageInput.value.trim()
              : ''
        }
      })
    })
      .then(response => response.json())
      .then(cart => {
        console.log(
          'Atributos de regalo actualizados:',
          cart.attributes
        );
      })
      .catch(error => {
        console.error(
          'Error al actualizar los atributos del regalo:',
          error
        );
      });

    return;
  }

  const messageInput = event.target.closest(
    '#cart-gift-message, #mini-cart-gift-message'
  );

  if (messageInput) {

    const container = messageInput.closest(
      '.gift-cart-attributes, .mini-cart__gift-attributes'
    );

    const checkbox = container
      ? container.querySelector(
          '#cart-gift-checkbox, #mini-cart-gift-checkbox'
        )
      : null;

    if (!checkbox) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Este es un regalo.': checkbox.checked ? 'Sí' : '',
          'Escribe aquí tu mensajito':
            checkbox.checked
              ? messageInput.value.trim()
              : ''
        }
      })
    })
      .then(response => response.json())
      .then(cart => {
        console.log(
          'Mensaje de regalo actualizado:',
          cart.attributes
        );
      })
      .catch(error => {
        console.error(
          'Error al actualizar el mensaje de regalo:',
          error
        );
      });
  }

});